document.addEventListener("alpine:init", () => {
    Alpine.data("ipBar", (selectedTerritory, selectedUrl) => ({
        ipBarIsOpen: false, 
        redirectUrl: '',
        selectedTerritory: '',

        init(){
            this.selectedTerritory = selectedTerritory;
            this.redirectUrl = selectedUrl;
        },

        switchLang(langCode, url) {
            if(this.selectedTerritory === langCode) return;

            this.selectedTerritory = langCode;
            this.redirectUrl = url;
        },

        redirectToLang() {
            pegasus.setCookie('confirmed_territory', this.selectedTerritory, 30);
            if(this.redirectUrl) {
                console.log('redirecting to ', this.redirectUrl);
                window.location.href = this.redirectUrl;
                return;
            }
            this.$root.remove();
        },
    }));
});